import React, { Component } from "react";
import { EVENT } from "../events/listEvents";

export default function maintenancePageChecker() {
  return (Child) => {
    return class extends Component {
      constructor(props) {
        super(props)
        this.state = {
          isMaintenance: false
        }
      }

      render() {
        return (
          <Child
            isMaintenance={this.state.isMaintenance}
            {...this.props} />
        );
      }

      componentDidMount() {
        window.listenEvent(EVENT.EnableMaintenancePage, this.enableMaintenancePage)
        window.listenEvent(EVENT.DisableMaintenancePage, this.disableMaintenancePage)
      }

      componentWillUnmount() {
        window.stopListenEvent(EVENT.EnableMaintenancePage, this.enableMaintenancePage)
        window.stopListenEvent(EVENT.DisableMaintenancePage, this.disableMaintenancePage)
      }

      enableMaintenancePage = () => {
        this.setState({
          isMaintenance: true
        });
      }

      disableMaintenancePage = () => {
        this.setState({
          isMaintenance: false
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/decorator/maintenancePageChecker.js